<template>
  <div class="relative">
    <AvatarGridSelect
      v-if="schema.pickIcon"
      v-model="selectedIcon"
      :icons="schema.iconList"
      class="avatar-select" />
    <ValidationObserver
      ref="inputObserver" >
      <ValidationProvider
        v-slot="{ errors, failedRules }"
        :name="schema.title"
        :rules="validatorsProcessed">
        <b-input
          ref="flowNameInputRef"
          v-model="flowName"
          autocomplete="off"
          class="sb2-bordered sb2-hoverable sb2-focusable"
          :class="{ indent: schema.pickIcon, empty: !flowName }"
          :placeholder="placeholder"
          @keydown="catchEnter" />
        <div
          v-if="schema.subtitle && !errors[0]"
          class="subtitle flex flex-align-center">
          <svg
            v-if="schema.subtitlePrefixIcon && typeof schema.subtitlePrefixIcon === 'string' && schema.subtitlePrefixIcon.endsWith('.svg')"
            class="mr-1 flex-start-image"
            :data-src="schema.subtitlePrefixIcon"
            fill="currentColor"
            width="10"
            height="10" />
          <img
            v-else-if="schema.subtitlePrefixIcon && typeof schema.subtitlePrefixIcon === 'string'"
            :src="schema.subtitlePrefixIcon"
            style="width: 10px; height: 10px;"
            class="mr-1 flex-start-image"
          >
          <SBIcon
            v-else-if="!schema.noSubtitlePrefixIcon"
            class="mr-1"
            :icon="SBIconList.INFO"
            :color="SBColors.greyLight"
            :size="10" />
          <span>{{ schema.subtitle }}</span>
        </div>
        <div
          v-if="errors[0]"
          class="error flex flex-align-center"
          :class="{ warning: warningValidators.includes(Object.keys(failedRules)[0])}">
          <SBIcon
            class="mr-1"
            :icon="warningValidators.includes(Object.keys(failedRules)[0]) ? SBIconList.INFO : SBIconList.ERROR"
            :color="warningValidators.includes(Object.keys(failedRules)[0]) ? '#DEBD30' : SBColors.redPrimary"
            :size="10" />
          <span>{{ schema.validatorMessages && schema.validatorMessages[Object.keys(failedRules)[0]] ? schema.validatorMessages[Object.keys(failedRules)[0]] : errors[0] }}</span>
        </div>
      </ValidationProvider>
    </ValidationObserver>
  </div>
</template>

<script>
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import AvatarGridSelect from './AvatarGridSelect';

export default {
  name: 'BInputWrapper',
  components: {
    SBIcon,
    AvatarGridSelect,
  },
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    validators: {
      type: String,
      default: '',
    },
    schema: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      initialValue: '',
      flowName: '',
      selectedIcon: 0,
      SBColors,
      SBIconList,
    };
  },
  computed: {
    warningValidators() {
      return this.schema.warningValidators ? this.schema.warningValidators.split(',') : [];
    },
    validatorsProcessed() {
      return this.validators ? this.validators.replace('checkDuplicate:', `checkDuplicate:${this.initialValue},`) : '';
    },
  },
  watch: {
    flowName: {
      handler() {
        this.emitData();
      },
      immediate: false,
    },
    selectedIcon() {
      this.emitData();
    },
  },
  mounted() {
    if (this.schema.value) {
      if (this.isObject(this.schema.value)) {
        this.flowName = this.schema.value.value;
        this.selectedIcon = this.schema.value.icon;
        this.initialValue = this.schema.value.value;
      } else {
        this.flowName = this.schema.value;
        this.initialValue = this.schema.value;
      }
    }
    setTimeout(() => {
      this.emitData(true);
      if (this.schema.value) {
        // this.$refs.inputObserver.validate();
      }
    }, 0);

    if (this.schema.stepID) {
      this.$eventBus.$on(`validate-${this.schema.stepID}`, () => {
        if (!this.$refs.inputObserver) return;
        this.$refs.inputObserver.validate();
      });
    }

    // NOTE: Once we get to the rewrite of the app we should enable setting the text on the input and text fields without taking the focus automatically. Then this timeout wouldn't be needed and we could set the focus element instantly.
    // NOTE: For start extend the loader untill the form is fully loaded and then remove it and set focus where it should be.
    // setTimeout(() => {
    //   if (this.schema.focus) {
    //     this.emitData();
    //     this.$refs.flowNameInputRef.focus();
    //   }
    // }, 3000);
  },
  methods: {
    catchEnter(e) {
      if (e.keyCode === 13) {
        e.preventDefault();
        this.$emit('next');
      }
    },
    /** Checks if the validator errors are all of warning type. */
    onlyWarnings() {
      const fields = Object.values(this.$refs.inputObserver.fields).map(field => Object.keys(field.failedRules)).flat(Infinity);
      const someTest = fields.length ? !fields.some(failed => !this.warningValidators.includes(failed)) : false; // if there are no fields, return false because it means the field is validated silently and no failedRules are being recorded
      return someTest;
    },
    emitData(reset = false) {
      if (!this.$refs.inputObserver) return;
      this.$refs.inputObserver.validate({ silent: !reset })
        .then((valid) => {
          this.$emit('input', {
            valid: valid || this.onlyWarnings(),
            name: this.schema.returnKey || '',
            data: this.schema.pickIcon ? {
              value: {
                value: this.flowName,
                icon: this.selectedIcon,
              },
            } : {
              value: this.flowName,
            },
          });
        })
        .finally(() => {
          if (reset) this.$refs.inputObserver.reset();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
input.form-control {
  height: 34px;
}

.avatar-select {
  position: absolute;
  top: 1px;
  left: 1px;
  border-radius: 10px 0 0 10px !important;
  z-index: 1;
}

.indent {
  padding-left: 50px !important;
}

.flex-start-image {
  top: 1px;
  position: relative;
}
</style>
